<template>
  <div class="mask" v-show="show" @click="preventClick">
    <div class="toast-box">
      <div class="img-box" v-show="type === 'loading'">
        <img class="img" src="../../assets/img/loading.gif" alt="">
      </div>
      <div class="txt">{{note}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "toast",
  props: {
    duration: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      iconRight: "",
      iconSign: "",
      imgs: [],
      gif: "",
      tid: null,
      img: "",
      note: "",
      type: "",
      show: false
    };
  },
  created() {
    if (this.show) {
      this.toastOpen();
    } else {
      this.init();
    }
  },
  methods: {
    preventClick() {
      return false;
    },
    init() {
      if (this.type == "loading") {
        this.img = this.gif;
      } else if (this.type == "right") {
        this.img = this.iconRight;
      } else if (this.type == "sign") {
        this.img = this.iconSign;
      }
    },
    toastOpen(type, note) {
      let self = this;
      if (type) {
        this.type = type;
      }
      if (note) {
        this.note = note;
      }
      this.clearAllTimeout();
      this.init();
      this.show = true;

      if (this.type == "loading") {
        this.img = this.gif;
      } else {
        this.tid = setTimeout(() => {
          self.tid = null;
          self.toastClose();
        }, this.duration);
      }
    },
    toastClose() {
      this.show = false;
      this.clearAllTimeout();
    },
    clearAllTimeout() {
      if (this.tid) {
        clearTimeout(this.tid);
        this.tid = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mask {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}
.toast-box {
  display: flex;
  justify-content: center;
  max-width: 274px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.7);
  flex-wrap: wrap;
}
.img-box {
  .img {
    margin-top: 10px;
    width: 20px;
    height: 20px;
  }
}
.txt {
  width: 100%;
  font-size: 16px;
  line-height: 22px;
  color: #fff;
  margin: 11px 14px;
  text-align: center;
}
</style>
